<template>
  <div class="w-100 bg-white">
    <div id="hotel-room"></div>
    <template v-if="getMerchant().booking_engine_header_type == 'BANNER'">
      <div
        class="bg-top-black position-absolute d-table no-ws pl-3 cursor-pointer"
        @click="backToHomepage()"
        style="left: 0">
        <img
          src="../../../assets/img/icon/back-white.png"
          height="20"
          class="d-inline-block align-middle" />
        <p
          class="mb-0 body-2-2 p-3 text-white font-semibold d-inline-block align-middle">
          Back to Homepage
        </p>
      </div>

      <div class="bg-top-black position-absolute d-table" style="right: 0">
        <p
          @click="toggleShowLanguagePopup(true)"
          class="mb-0 body-2-2 p-3 text-white font-semibold cursor-pointer">
          <span v-if="showLanguageMenu">{{ $t('hotel.language') }} | </span>{{ getCurrency().name }} ({{
            getCurrency().code
          }})
        </p>
      </div>

      <!-- header image -->
      <div
        class="bg-white py-5 bg-room"
        id="search"
        :style="{
          'background-image':
            'url(' + getMerchant().booking_engine_hero_banner + ')',
        }">
        <div class="container-desktop pb-3 mt-3">
          <template v-if="getMerchant().search_room_is_show_merchant_image">
            <img
              :src="getMerchant().image_url"
              class="mx-auto d-table"
              :style="{
                width: getMerchant().search_room_merchant_image_width + 'px',
              }" />
          </template>
          <p
            v-if="getMerchant().search_room_is_show_merchant_name"
            class="mb-0 body-2-2 text-40 font-extrabold text-center text-white text-shadow">
            {{ getMerchant().name }}
          </p>
          <div
            class="mx-auto d-table"
            v-if="getMerchant().search_room_is_show_merchant_star">
            <img
              src="../../../assets/img/icon/hotel-star.png"
              width="20"
              class="d-inline-block mb-3"
              v-for="data in getMerchant().star" />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="getMerchant().booking_engine_header_type == 'NAVBAR'">
      <TopNavbar
        @openCurLang="toggleShowLanguagePopup"
        @backClicked="backToHomepage" />
    </template>
    <div class="position-relative" style="top: 0px" id="category-room"></div>

    <!-- PRODUCT TAB -->
    <div class="px-3 w-100 pt-4 pb-3">
      <div class="px-5">
        <HotelProductTab
          items-align="center"
          v-if="getMerchant().additional_appearance === 'SEARCH_ROOM'" />
      </div>
    </div>

    <!-- ROOM LIST -->
    <template
      v-if="
        iActiveHotelModuleRoom() ||
        getMerchant().additional_appearance === 'CART'
      ">
      <!-- search -->
      <div
        class="w-100 bg-white"
        style="height: 160px"
        v-if="header_scroll && scrollPosition > 300 && !show_rate"></div>
      <transition name="fade">
        <div
          class="padding-y-6px"
          :class="{
            'z-index-1042 position-relative w-100 bg-white':
              popup_active == 'search',
          }"
          :style="[
            popup_active == 'cr_lang'
              ? { 'z-index': '1038' }
              : { 'z-index': '' },
          ]">
          <div
            class="w-100 z-index-1041 bg-white"
            :class="{
              'position-fixed w-100 z-index-1042 top-0 box-shadow-nav-desktop':
                header_scroll && scrollPosition > 300 && !show_rate,
            }"
            :style="[
              popup_active == 'cr_lang'
                ? { 'z-index': '1038!important' }
                : { 'z-index': '1040' },
            ]">
            <div>
              <div class="py-2 my-1">
                <div class="bg-white border-top border-bottom">
                  <div class="px-5">
                    <div class="px-3">
                      <div class="row no-gutters">
                        <div
                          v-if="$showCommunity()"
                          class="col-3 border-right cursor-pointer"
                          @click="toggleFilterActive('merchant')">
                          <div class="py-4 pr-3 position-relative">
                            <div class="row slim-grid-row">
                              <div class="col-1 align-self-center">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                              <div class="col-10 align-self-center">
                                <div class="pl-1">
                                  <p
                                    class="mb-0 font-semibold text-13 color-grey">
                                    Property
                                  </p>
                                  <p
                                    class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px"
                                    v-if="merchant_community.selected">
                                    {{ merchant_community.selected.name }}
                                  </p>
                                </div>
                              </div>
                              <div class="col-1 align-self-center">
                                <!-- <img class="cursor-pointer" src="../../../assets/img/icon/close.png" width="10" /> -->
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M2.47363 4.51844C2.64408 4.34457 2.9108 4.32877 3.09876 4.47102L3.15261 4.51844L6.99967 8.44283L10.8467 4.51844C11.0172 4.34457 11.2839 4.32877 11.4719 4.47102L11.5257 4.51844C11.6962 4.69231 11.7117 4.96438 11.5722 5.15611L11.5257 5.21104L7.33916 9.48156C7.16871 9.65543 6.90199 9.67123 6.71403 9.52898L6.66019 9.48156L2.47363 5.21104C2.28613 5.01978 2.28613 4.7097 2.47363 4.51844Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="border-right cursor-pointer"
                          :class="
                            $showCommunity()
                              ? 'col-3'
                              : 'col-5 col-md-5 col-lg-5 col-xl-4'
                          "
                          @click="toggleFilterActive('date')">
                          <div class="py-4 px-3">
                            <div class="row slim-grid-row">
                              <div
                                class="col-1 align-self-center"
                                @click="openFilterDate()">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                              <div
                                class="col-10 align-self-center"
                                :key="filter_key">
                                <div class="pl-1">
                                  <p
                                    @click="openFilterDate()"
                                    class="mb-0 font-semibold text-13 color-grey">
                                    {{ $t('hotel.date.check-in') }} -
                                    {{ $t('hotel.date.check-out') }}
                                  </p>
                                  <CalendarRoom
                                    ref="filter_date"
                                    :date_default="search_filter_date"
                                    :filter_guest="search_filter_guest"
                                    @finish="applyDateFilter"
                                    wrapper_class="calendar-be-active calendar-be text-14 font-semibold text-semi-dark mt-3px z-index-1038 d-inline-block align-top w-100">
                                  </CalendarRoom>
                                </div>
                              </div>
                              <div
                                class="col-1 align-self-center"
                                @click="openFilterDate()">
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M2.47363 4.51844C2.64408 4.34457 2.9108 4.32877 3.09876 4.47102L3.15261 4.51844L6.99967 8.44283L10.8467 4.51844C11.0172 4.34457 11.2839 4.32877 11.4719 4.47102L11.5257 4.51844C11.6962 4.69231 11.7117 4.96438 11.5722 5.15611L11.5257 5.21104L7.33916 9.48156C7.16871 9.65543 6.90199 9.67123 6.71403 9.52898L6.66019 9.48156L2.47363 5.21104C2.28613 5.01978 2.28613 4.7097 2.47363 4.51844Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="border-right cursor-pointer"
                          :class="
                            $showCommunity()
                              ? 'col-2'
                              : 'col-3 col-md-3 col-lg-3 col-xl-4'
                          "
                          @click="toggleFilterActive('guest')">
                          <div class="py-4 px-3">
                            <div class="row slim-grid-row">
                              <div class="col-1 align-self-center">
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                              <div class="col-10 align-self-center">
                                <div class="pl-3">
                                  <p
                                    class="mb-0 font-semibold text-13 color-grey">
                                    {{ $t('hotel.guests.guests') }}
                                  </p>
                                  <p
                                    class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px">
                                    {{ search_filter_guest.adult }}
                                    {{ $t('hotel.adults.adults')
                                    }}<template
                                      v-if="
                                        getMerchant()
                                          .search_room_is_show_filter_pax_child
                                      "
                                      >, {{ search_filter_guest.child }}
                                      {{
                                        $t('hotel.children.children')
                                      }}</template
                                    ><template
                                      v-if="
                                        getMerchant()
                                          .search_room_is_show_filter_pax_infant
                                      "
                                      >, {{ search_filter_guest.infant }}
                                      {{
                                        $t('hotel.infants.infants')
                                      }}</template
                                    >
                                  </p>
                                </div>
                                <svg
                                  width="14"
                                  class="position-absolute"
                                  style="right: -12px; top: 20px"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M2.47363 4.51844C2.64408 4.34457 2.9108 4.32877 3.09876 4.47102L3.15261 4.51844L6.99967 8.44283L10.8467 4.51844C11.0172 4.34457 11.2839 4.32877 11.4719 4.47102L11.5257 4.51844C11.6962 4.69231 11.7117 4.96438 11.5722 5.15611L11.5257 5.21104L7.33916 9.48156C7.16871 9.65543 6.90199 9.67123 6.71403 9.52898L6.66019 9.48156L2.47363 5.21104C2.28613 5.01978 2.28613 4.7097 2.47363 4.51844Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="border-right cursor-pointer"
                          :class="
                            $showCommunity()
                              ? 'col-2'
                              : 'col-2 col-md-2 col-lg-2 col-xl-2'
                          "
                          @click="toggleFilterActive('promo')">
                          <div class="py-4 px-3">
                            <div class="row slim-grid-row">
                              <div class="col-1 align-self-center">
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.3992 9.14599L21.1194 9.86599C21.6897 10.426 21.9998 11.186 21.9998 11.986C22.0098 12.786 21.6997 13.547 21.1395 14.116C21.1328 14.1233 21.1261 14.1298 21.1194 14.1362C21.1161 14.1394 21.1128 14.1427 21.1094 14.146L20.3992 14.856C20.1191 15.136 19.959 15.516 19.959 15.917V16.946C19.959 18.606 18.6085 19.957 16.9479 19.957H15.9176C15.5174 19.957 15.1373 20.116 14.8572 20.396L14.1369 21.116C13.5467 21.707 12.7764 21.996 12.0061 21.996C11.2359 21.996 10.4656 21.707 9.87537 21.127L9.14511 20.396C8.865 20.116 8.48487 19.957 8.08472 19.957H7.05435C5.39375 19.957 4.04326 18.606 4.04326 16.946V15.917C4.04326 15.516 3.8832 15.136 3.6031 14.846L2.88284 14.136C1.71241 12.967 1.70241 11.056 2.87283 9.87699L3.6031 9.14599C3.8832 8.86599 4.04326 8.48599 4.04326 8.07599V7.05599C4.04326 5.39599 5.39375 4.04699 7.05435 4.04699H8.08472C8.48487 4.04699 8.865 3.88599 9.14511 3.60599L9.86537 2.88599C11.0358 1.70699 12.9465 1.70699 14.1269 2.87699L14.8572 3.60599C15.1373 3.88599 15.5174 4.04699 15.9176 4.04699H16.9479C18.6085 4.04699 19.959 5.39599 19.959 7.05599V8.08699C19.959 8.48599 20.1191 8.86599 20.3992 9.14599ZM9.42521 15.446C9.66529 15.446 9.88537 15.356 10.0454 15.186L15.1873 10.047C15.5274 9.70699 15.5274 9.14599 15.1873 8.80599C14.8472 8.46699 14.297 8.46699 13.9569 8.80599L8.81499 13.946C8.47486 14.286 8.47486 14.846 8.81499 15.186C8.97504 15.356 9.19512 15.446 9.42521 15.446ZM13.6968 14.566C13.6968 15.056 14.0869 15.446 14.5771 15.446C15.0572 15.446 15.4474 15.056 15.4474 14.566C15.4474 14.087 15.0572 13.696 14.5771 13.696C14.0869 13.696 13.6968 14.087 13.6968 14.566ZM9.43521 8.55599C9.91539 8.55599 10.3055 8.94599 10.3055 9.42599C10.3055 9.91699 9.91539 10.306 9.43521 10.306C8.95504 10.306 8.55489 9.91699 8.55489 9.42599C8.55489 8.94599 8.95504 8.55599 9.43521 8.55599Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                              <div class="col-10 align-self-center">
                                <div class="pl-3">
                                  <p
                                    class="mb-0 font-semibold text-13 color-grey">
                                    {{ $t('hotel.promo.promo-code') }}
                                  </p>
                                  <p
                                    class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px"
                                    v-if="search_filter_promo_code == ''">
                                    -
                                  </p>
                                  <p
                                    class="mb-0 text-14 font-semibold text-semi-dark text-truncate mt-3px"
                                    v-else>
                                    {{ search_filter_promo_code }}
                                  </p>
                                </div>
                                <svg
                                  width="14"
                                  height="14"
                                  class="position-absolute"
                                  style="right: -12px; top: 20px"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M2.47363 4.51844C2.64408 4.34457 2.9108 4.32877 3.09876 4.47102L3.15261 4.51844L6.99967 8.44283L10.8467 4.51844C11.0172 4.34457 11.2839 4.32877 11.4719 4.47102L11.5257 4.51844C11.6962 4.69231 11.7117 4.96438 11.5722 5.15611L11.5257 5.21104L7.33916 9.48156C7.16871 9.65543 6.90199 9.67123 6.71403 9.52898L6.66019 9.48156L2.47363 5.21104C2.28613 5.01978 2.28613 4.7097 2.47363 4.51844Z"
                                    fill="#999999" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          :class="
                            $showCommunity()
                              ? 'col-2'
                              : 'col-2 col-md-2 col-lg-2 col-xl-2'
                          ">
                          <div class="pl-4 py-4">
                            <button
                              type="button"
                              class="button-secondary w-100"
                              @click="searchClicked()">
                              <img
                                src="../../../assets/img/icon/search-white.png"
                                width="12"
                                class="d-inline-block mr-2 position-relative"
                                style="top: -2px" />{{ $t('hotel.search') }}
                            </button>
                          </div>
                        </div>
                        <!--  -->
                        <div
                          v-if="$showCommunity()"
                          class="col-4 col-md-5 col-lg-5 col-xl-3">
                          <div
                            class="ota-property-select w-100 pl-2 z-index-1028"
                            v-if="filter_active == 'merchant'"
                            style="top: 5px">
                            <div
                              class="rounded-4 bg-white border-semi-grey w-100"
                              style="max-height: 60vh; overflow-y: auto">
                              <div
                                class="w-100 p-3 ota-property-select-item"
                                v-for="merchant in merchant_community.list"
                                :class="{
                                  'active-item':
                                    merchant_community.selected.id &&
                                    merchant.id ==
                                      merchant_community.selected.id,
                                }"
                                @click="selectOtherMerchant(merchant)">
                                <p class="mb-0 body-2-1">{{ merchant.name }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="$showCommunity()"
                          class="col-8 col-md-7 col-lg-7 col-xl-3"></div>
                        <div
                          v-else
                          class="col-4 col-md-5 col-lg-5 col-xl-4"></div>
                        <div
                          class="col-8 col-md-7 col-lg-7"
                          :class="$showCommunity() ? 'col-xl-3' : 'col-xl-8'">
                          <div
                            class="position-absolute bg-white border rounded-6 px-4 py-2 box-shadow-primary rooms-guest z-index-1039"
                            style="top: -4px; left: 2px; width: 310px"
                            v-if="filter_active == 'guest'">
                            <div class="">
                              <div
                                class="row pt-2 no-gutters pb-3"
                                :class="{
                                  'mb-2 border-bottom':
                                    getMerchant()
                                      .search_room_is_show_filter_pax_child ||
                                    getMerchant()
                                      .search_room_is_show_filter_pax_infant,
                                }">
                                <div class="col-8">
                                  <p class="mb-0 body-2-2 font-bold text-18">
                                    {{ $t('hotel.adults.adults') }}
                                  </p>
                                  <p class="mb-0 body-2-2 font-regular">
                                    {{ getMerchant().adult_description }}
                                  </p>
                                </div>
                                <div class="col-4 text-center mt-1">
                                  <div
                                    class="row py-1 text-right w-100 no-gutters">
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/decrement.png"
                                        class="cursor-disable border rounded-100 p-2"
                                        width="30"
                                        v-if="
                                          search_filter_guest.adult <= '1'
                                        " />
                                      <img
                                        src="../../../assets/img/icon/minus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        v-else
                                        @click="
                                          toggleCounter('min', 'adult')
                                        " />
                                    </div>
                                    <div class="col-4 text-center">
                                      <p
                                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                                        style="top: 3px">
                                        {{ search_filter_guest.adult }}
                                      </p>
                                    </div>
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/plus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        @click="
                                          toggleCounter('plus', 'adult')
                                        " />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="
                                  getMerchant()
                                    .search_room_is_show_filter_pax_child
                                "
                                class="row pt-2 pb-3 my-2 no-gutters border-bottom">
                                <div class="col-8">
                                  <p class="mb-0 body-2-2 font-bold text-18">
                                    {{ $t('hotel.children.children') }}
                                  </p>
                                  <p class="mb-0 body-2-2 font-regular">
                                    {{ getMerchant().children_description }}
                                  </p>
                                </div>
                                <div class="col-4 text-center mt-1">
                                  <div
                                    class="row py-1 text-right w-100 no-gutters">
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/decrement.png"
                                        class="cursor-disable border rounded-100 p-2"
                                        width="30"
                                        v-if="
                                          search_filter_guest.child == '0'
                                        " />
                                      <img
                                        src="../../../assets/img/icon/minus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        v-else
                                        @click="
                                          toggleCounter('min', 'child')
                                        " />
                                    </div>
                                    <div class="col-4 text-center">
                                      <p
                                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                                        style="top: 3px">
                                        {{ search_filter_guest.child }}
                                      </p>
                                    </div>
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/plus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        @click="
                                          toggleCounter('plus', 'child')
                                        " />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="
                                  getMerchant()
                                    .search_room_is_show_filter_pax_infant
                                "
                                class="row pt-2 pb-3 no-gutters">
                                <div class="col-8">
                                  <p class="mb-0 body-2-2 font-bold text-18">
                                    {{ $t('hotel.infants.infants') }}
                                  </p>
                                  <p class="mb-0 body-2-2 font-regular">
                                    {{ getMerchant().infant_description }}
                                  </p>
                                </div>
                                <div class="col-4 text-center mt-1">
                                  <div
                                    class="row py-1 text-right w-100 no-gutters mt-2">
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/decrement.png"
                                        class="cursor-disable border rounded-100 p-2"
                                        width="30"
                                        v-if="
                                          search_filter_guest.infant == '0'
                                        " />
                                      <img
                                        src="../../../assets/img/icon/minus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        v-else
                                        @click="
                                          toggleCounter('min', 'infant')
                                        " />
                                    </div>
                                    <div class="col-4 text-center">
                                      <p
                                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                                        style="top: 3px">
                                        {{ search_filter_guest.infant }}
                                      </p>
                                    </div>
                                    <div class="col-4 text-center">
                                      <img
                                        src="../../../assets/img/icon/plus-black.png"
                                        class="cursor-pointer border rounded-100 p-2"
                                        width="30"
                                        @click="
                                          toggleCounter('plus', 'infant')
                                        " />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-7 col-md-7 col-lg-7 col-xl-7"></div>
                        <div class="col-5 col-md-5 col-lg-5 col-xl-5">
                          <div
                            class="position-absolute bg-white border rounded-6 px-4 py-2 box-shadow-primary rooms-guest z-index-1039"
                            style="top: -4px; left: 120px"
                            v-if="filter_active == 'promo'">
                            <div class="">
                              <div class="row py-2 mb-2 no-gutters">
                                <div class="col-12">
                                  <PromoCode
                                    :data.sync="search_filter_promo_code"
                                    :date.sync="search_filter_date"
                                    @hitSearch="searchClicked"></PromoCode>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-5 pb-1">
              <div class="px-3">
                <div class="row">
                  <div class="col-6 col-md-5 col-lg-6 col-xl-6">
                    <div class="row text-left mb-2">
                      <div class="pl-3 d-inline-block">
                        <p
                          class="mb-0 body-2-2 font-bold text-16 d-inline-block mt-2 pr-2">
                          {{ $t('hotel.filter.filter') }}
                        </p>
                      </div>
                      <div class="d-inline-block">
                        <div
                          class="cursor-pointer rounded-4 d-flex w-auto delay"
                          :class="{
                            'w-256px':
                              is_range_price.use_min || is_range_price.use_max,
                          }"
                          v-if="
                            range_price_active &&
                            (is_range_price.use_min || is_range_price.use_max)
                          ">
                          <div
                            class="d-inline-block cursor-pointer bg-green py-2 pl-3 rounded-top-bottom-left-4"
                            @click="
                              toggleFilterActive('filter-price');
                              popup_filter_price = true;
                            ">
                            <p
                              class="body-2-2 mb-0 font-regular text-12 text-white position-relative"
                              style="top: 3px">
                              <template
                                v-if="
                                  is_range_price.use_min &&
                                  is_range_price.use_max
                                ">
                                {{ formatCurrency(range_price[0], true) }} -
                                {{ formatCurrency(range_price[1], true) }}
                              </template>
                              <template
                                v-else-if="
                                  is_range_price.use_min &&
                                  !is_range_price.use_max
                                ">
                                Start from
                                {{ formatCurrency(range_price[0], true) }}
                              </template>
                              <template
                                v-else-if="
                                  !is_range_price.use_min &&
                                  is_range_price.use_max
                                ">
                                Maximum price
                                {{ formatCurrency(range_price[1], true) }}
                              </template>
                            </p>
                          </div>
                          <div
                            class="d-inline-block text-center bg-green py-2 pl-3 pr-3 rounded-top-bottom-right-4"
                            @click="toggleFilterPrice('delete')">
                            <img
                              src="../../../assets/img/icon/cancel.png"
                              width="12"
                              class="position-relative"
                              style="top: -2px" />
                          </div>
                        </div>
                        <div
                          class="text-center py-2 rounded-4 mr-3 px-3 d-inline-block border cursor-pointer delay"
                          v-else>
                          <div
                            @click="
                              toggleFilterActive('filter-price');
                              popup_filter_price = true;
                            ">
                            <p
                              class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14">
                              <i
                                class="simple-icon-tag mr-2 position-relative"
                                style="top: 1px"></i
                              >{{ $t('hotel.filter.all-prices') }}
                              <i
                                class="simple-icon-arrow-down position-relative"
                                style="top: 1px"></i>
                            </p>
                            <!-- <p class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"><i class="simple-icon-tag mr-2 position-relative" style="top: 1px;"></i>{{$t('general.price')}} <i class="simple-icon-arrow-down position-relative" style="top: 1px;"></i></p> -->
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="show_filter_detail"
                        class="text-center py-2 rounded-4 ml-2 px-3 d-inline-block bg-green">
                        <p
                          class="body-2-2 mb-0 text-14 text-white d-inline-block align-middle mr-3">
                          {{ getBeFilterDetail().data.name }}
                        </p>
                        <img
                          @click="clearFilterDetail"
                          src="../../../assets/img/icon/cancel.png"
                          width="12"
                          class="d-inline-block align-middle cursor-pointer" />
                      </div>
                    </div>
                    <div
                      class="position-absolute p-3 rounded-4 border rooms-guest bg-white box-shadow-main z-index-1037"
                      v-if="
                        filter_active == 'filter-price' && popup_filter_price
                      "
                      style="
                        width: 400px;
                        left: 69px;
                        top: 48px;
                        box-shadow: 0px 0px 10px 1px #c2c2c247;
                      ">
                      <p class="mb-2 pb-2 body-1-2 w-100 border-bottom">
                        {{ $t('hotel.filter.desc') }}
                      </p>
                      <div class="row no-gutters mt-2">
                        <div class="col-5 align-self-center">
                          <div class="w-100 mb-1">
                            <div
                              class="w-16px rounded border-2-green text-center delay mr-1 d-inline-block cursor-pointer align-middle"
                              :class="{ 'bg-green': is_range_price.use_min }"
                              @click="isToggleEfect('use_min', 'toggle')">
                              <img
                                src="../../../assets/img/icon/correct-white.png"
                                class="position-relative"
                                width="10"
                                style="top: -8px" />
                            </div>
                            <p
                              class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle"
                              @click="isToggleEfect('use_min', 'toggle')">
                              Minimun
                            </p>
                          </div>
                          <!-- <input
                            style="height: 39px !important;"
                            @keypress="inputNumberDotCommaOnly"
                            type="text"
                            class="form-control d-inline-block py-1 body-2-2 font-regular"
                            ref="min"
                            v-if="is_range_price.min"
                            v-model="range_price[0]"
                            @blur="isToggleEfect('min', false)"
                          /> -->
                          <input-currency
                            v-model="range_price[0]"
                            v-if="is_range_price.min"
                            @onback-blur="isToggleEfect('min', false)">
                          </input-currency>
                          <p
                            class="border mb-0 p-2 rounded-4 body-2-2 font-semibold"
                            :class="{
                              'cursor-disable bg-custom-light':
                                !is_range_price.use_min,
                            }"
                            v-else
                            @click="isToggleEfect('min', true)">
                            {{ formatCurrency(range_price[0], true) }}
                          </p>
                        </div>
                        <div class="col-2 align-self-center pt-4">
                          <p
                            class="text-20 mt-2 font-weight-bold w-100 text-center">
                            -
                          </p>
                        </div>
                        <div class="col-5 align-self-center">
                          <div class="w-100 mb-1">
                            <div
                              class="w-16px rounded border-2-green text-center delay mr-1 d-inline-block cursor-pointer align-middle"
                              :class="{ 'bg-green': is_range_price.use_max }"
                              @click="isToggleEfect('use_max', 'toggle')">
                              <img
                                src="../../../assets/img/icon/correct-white.png"
                                class="position-relative"
                                width="10"
                                style="top: -8px" />
                            </div>
                            <p
                              class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle"
                              @click="isToggleEfect('use_max', 'toggle')">
                              Maximum
                            </p>
                          </div>
                          <!-- <input
                            style="height: 39px !important;"
                            @keypress="inputNumberDotCommaOnly"
                            type="text"
                            class="form-control d-inline-block py-1 body-2-2 font-regular"
                            ref="max"
                            v-if="is_range_price.max"
                            v-model="range_price[1]"
                            @blur="isToggleEfect('max', false)"
                          /> -->
                          <input-currency
                            v-model="range_price[1]"
                            v-if="is_range_price.max"
                            @onback-blur="isToggleEfect('max', false)">
                          </input-currency>
                          <p
                            class="border mb-0 p-2 rounded-4 body-2-2 font-semibold"
                            :class="{
                              'cursor-disable bg-custom-light':
                                !is_range_price.use_max,
                            }"
                            v-else
                            @click="isToggleEfect('max', true)">
                            {{ formatCurrency(range_price[1], true) }}
                          </p>
                        </div>
                        <div class="col-12 text-right mt-3">
                          <button
                            type="button"
                            class="button-primary box-shadow-none border-black font-bold bg-white text-dark px-4 py-2 text-12"
                            @click="toggleFilterPrice('cancel')">
                            {{ $t('general.cancel') }}
                          </button>
                          <button
                            type="button"
                            class="button-primary px-4 py-2 text-12"
                            @click="toggleFilterPrice('add')">
                            {{ $t('general.apply') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-7 col-lg-6 col-xl-6">
                    <div class="d-inline-block float-right">
                      <p class="mb-0 body-2-2 font-bold text-16 d-inline-block">
                        {{ $t('hotel.sort-by') }}
                      </p>
                      <div
                        class="text-center py-2 rounded-4 ml-2 px-3 d-inline-block cursor-pointer"
                        v-for="(data, index) in category_list"
                        :class="{ 'border-green': is_active == data.slug }"
                        @click="toggleSortBy(data.slug)"
                        style="border: 1px solid #dee2e6">
                        <p
                          class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"
                          :class="{
                            'font-bold text-green': is_active == data.slug,
                          }">
                          {{ data.name }}
                        </p>
                      </div>
                      <div
                        class="d-inline-block ml-3"
                        v-if="map_list.length > 0">
                        <div
                          class="text-center py-2 rounded-4 px-3 d-inline-block cursor-pointer"
                          :class="{ 'border-green': view_mode == 'list' }"
                          @click="toggleMapView('list')"
                          style="border: 1px solid #dee2e6">
                          <p
                            class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"
                            :class="{
                              'font-bold text-green': view_mode == 'list',
                            }">
                            List View
                          </p>
                        </div>
                        <div
                          class="text-center py-2 rounded-4 ml-2 px-3 d-inline-block cursor-pointer"
                          :class="{ 'border-green': view_mode == 'map' }"
                          @click="toggleMapView('map')"
                          style="border: 1px solid #dee2e6">
                          <p
                            class="body-2-2 mb-0 cursor-pointer delay font-semibold rounded-4 text-14"
                            :class="{
                              'font-bold text-green': view_mode == 'map',
                            }">
                            Map View
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- room list -->
      <b-skeleton-wrapper :loading="is_load && view_mode == 'list'">
        <template #loading>
          <div class="pb-4 px-3 z-index-1028">
            <div class="px-5 bg-white pb-3">
              <b-row>
                <b-col cols="9">
                  <b-row class="mb-2" v-for="i in 2" :key="i">
                    <b-col cols="4">
                      <b-card body-class="p-0">
                        <b-skeleton-img
                          no-aspect
                          width="100%"
                          height="160px"
                          card-img="top"></b-skeleton-img>
                        <b-card-body>
                          <div class="mb-2">
                            <b-skeleton width="80%" height="30px"></b-skeleton>
                          </div>
                          <b-row class="slim-grid-row">
                            <b-col cols="3">
                              <b-skeleton
                                width="100%"
                                height="20px"></b-skeleton>
                            </b-col>
                            <b-col cols="3">
                              <b-skeleton
                                width="100%"
                                height="20px"></b-skeleton>
                            </b-col>
                          </b-row>
                          <b-skeleton
                            width="30%"
                            height="20px"
                            class="my-2"></b-skeleton>
                          <b-row class="slim-grid-row">
                            <b-col cols="3" offset="9">
                              <b-skeleton
                                width="100%"
                                height="37px"></b-skeleton>
                            </b-col>
                          </b-row>
                        </b-card-body>
                      </b-card>
                    </b-col>
                    <b-col cols="8">
                      <div class="w-100 mb-3" v-for="j in 2" :key="j">
                        <b-card body-class="p-3">
                          <b-row>
                            <b-col cols="6">
                              <b-skeleton
                                width="100%"
                                height="30px"
                                class="mb-2"></b-skeleton>
                              <b-skeleton
                                width="50%"
                                height="15px"
                                class="mb-2"></b-skeleton>
                              <b-skeleton
                                width="30%"
                                height="15px"
                                class="mb-2"></b-skeleton>
                              <b-skeleton
                                width="40%"
                                height="15px"
                                class="mb-2"></b-skeleton>
                              <b-skeleton
                                width="20%"
                                height="20px"
                                class="mb-0"></b-skeleton>
                            </b-col>
                            <b-col cols="6">
                              <b-skeleton
                                width="40%"
                                height="30px"
                                class="ml-auto"></b-skeleton>
                              <b-skeleton
                                width="15%"
                                height="15px"
                                class="ml-auto"></b-skeleton>
                              <b-skeleton
                                width="45%"
                                height="15px"
                                class="ml-auto mb-2"></b-skeleton>
                              <b-skeleton
                                width="35%"
                                height="30px"
                                class="ml-auto"></b-skeleton>
                              <b-skeleton
                                width="15%"
                                height="15px"
                                class="ml-auto"></b-skeleton>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="3">
                  <b-card body-class="p-3">
                    <b-skeleton
                      width="40%"
                      height="25px"
                      class="mb-2"></b-skeleton>
                    <b-skeleton width="70%" height="35px"></b-skeleton>
                    <b-row>
                      <b-col cols="12" class="my-3">
                        <div class="d-block border-semi-grey w-100"></div>
                      </b-col>
                      <b-col cols="6">
                        <b-skeleton width="40%" height="30px"></b-skeleton>
                      </b-col>
                      <b-col cols="6">
                        <b-skeleton
                          width="40%"
                          height="30px"
                          class="ml-auto"></b-skeleton>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </div>
        </template>

        <div class="pb-4 px-3 z-index-1028">
          <div class="px-5 bg-white pb-3">
            <div v-if="getBePromotionFilterId()" class="pt-3">
              <BePromotionFilterChip @clear="clearPromotionFilter" />
            </div>
            <div
              v-if="$isNotEmptyV2(promoCodeWarningMessage)"
              class="w-100 d-flex align-items-center p-3 filter-outer mt-3 rounded promo-suggestion-box shadow-sm"
              @click="applyValidPromoDates"
            >
              <div class="icon-wrapper mr-3 flex-shrink-0 d-flex align-items-center justify-content-center">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 2H5C3.89 2 3.01 2.9 3.01 4L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM19 20H5V9H19V20ZM19 7H5V4H19V7ZM11 15H13V17H11V15ZM11 11H13V13H11V11ZM7 15H9V17H7V15ZM7 11H9V13H7V11ZM15 15H17V17H15V15ZM15 11H17V13H15V11Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="text-left" style="flex: 1; min-width: 0;">
                <p class="mb-0 text-15 font-bold promo-title">
                  {{ promoCodeErrorType === 'min_night_error' ? 'Minimum Stay Required' : 'Promo not available for selected dates' }}
                </p>
                <p class="mb-1 text-12 opacity-8 promo-desc" :title="promoCodeWarningMessage">
                  {{ promoCodeWarningMessage }}
                </p>
                <p class="mb-0 text-12 font-medium" style="color: var(--merchant-primary-color);" v-if="promoCodeValidDates">
                  Click to quickly adjust your dates
                </p>
              </div>
              <div
                v-if="promoCodeValidDates"
                class="apply-btn ml-3 flex-shrink-0 text-center"
              >
                {{ promoCodeErrorType === 'min_night_error' ? 'Extend Stay' : 'Apply Dates' }}
              </div>
            </div>
            <template v-else-if="view_mode == 'list' && room.length == 0 && !$isNotEmptyV2(promoCodeWarningMessage)">
              <div class="text-center py-4 mb-2">
                <BeMembershipPromoLoginBanner class="mb-3" @logged-in="toggleBeSearch()" />
                <FlexibleDateAlternatives
                  @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                  @select-date="applyFlexibleDate" />
                <template v-if="!flexible_dates_loading && flexible_dates.length == 0">
                  <img src="../../../assets/img/icon/404.png" width="200" />
                  <p
                    class="mb-1 mt-3 body-2-2 text-22 font-bold"
                    v-if="message != ''">
                    {{ message }}
                  </p>
                  <p
                    class="mb-1 mt-3 body-2-2 text-22 font-bold"
                    v-if="message == '' || message == undefined">
                    {{ $t('hotel.error.404') }}
                  </p>
                  <p class="mb-3 body-2-2 font-semibold">
                    {{ $t('hotel.error.404-desc') }}
                  </p>
                </template>
                <button
                  class="button-primary bg-white px-4 text-black mt-3"
                  @click="resetFilterSearch()">
                  {{ $t('hotel.filter.reset-filter') }}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="row mb-5">
                <div class="col-9">
                  <!-- Room -->
                  <div class="bg-light-desktop py-2 container rounded-4" v-if="!showMapArea">
                    <FlexibleDateAlternatives
                      v-if="isAllRoomsSoldOut"
                      class="mb-3"
                      @dates-loaded="flexible_dates = $event; flexible_dates_loading = false"
                      @select-date="applyFlexibleDate" />
                    <template v-for="(type, index) in room">
                      <BeRoomDesktop
                        @room_type_detail="detailRoom"
                        @toggleRateBreakdown="toggleRateBreakdown"
                        @toggleBookingRate="toggleBookingRate"
                        @toggleBookingRateCart="toggleBookingRateCart"
                        @handlePopupFilter="handlePopupFilter"
                        :rt_hightlight_index="is_room_rate_highlight"
                        :roomRateHighlight="roomRateHighlight"
                        :type="type"
                        :type_index="index"
                        :type_avlb="getRoomAvlb(type.id)"
                        :header_scroll="header_scroll"
                        :is_booking_dropdown="is_booking_dropdown"
                        :show_rate="show_rate"
                        :show_rate_breakdown="show_rate_breakdown"
                        :is_active="is_active"
                        :formatDate="formatDate"
                        :totalRateBreakdown="totalRateBreakdown"
                        :popup_active="popup_active">
                      </BeRoomDesktop>
                    </template>
                  </div>
                  <div
                    class="bg-light-desktop py-3 px-3 container rounded-4"
                    v-else>
                    <BeDigitalMap
                      :maps="rootMapList"
                      :merchant-id="getMerchant().id"
                      :selected-map-id.sync="active_root_map_id"
                      :is-searching="is_load"
                      @select-room-type="openMapRoomType" />
                  </div>
                </div>
                <!-- Cart -->
                <template>
                  <div class="col-3 position-relative">
                    <div
                      class="sticky mb-2"
                      :class="{
                        'top-5':
                          (!header_scroll ||
                            show_rate ||
                            show_rate_breakdown) &&
                          getMerchant().booking_engine_header_type == 'BANNER',
                        'top-90':
                          (!header_scroll ||
                            show_rate ||
                            show_rate_breakdown) &&
                          getMerchant().booking_engine_header_type == 'NAVBAR',
                      }"
                      style="top: 165px">
                      <div
                        class="bg-white mb-2 border rounded-4 box-shadow-main">
                        <div class="p-3 rounded-top-4 bg-top-black">
                          <p
                            class="mb-0 body-2-2 font-semibold text-16 text-white">
                            {{ $t('hotel.reservation-summary') }}
                          </p>
                          <p
                            class="mb-0 body-2-2 font-bold text-20 text-white"
                            :class="{ 'mb-2': getBeCartRoom().length > 0 }">
                            {{ getMerchant().name }}
                          </p>
                          <!-- <p class="mb-0 body-2-2" v-if="getBeCartRoom().length == 0">0 {{$t('hotel.guests.guests')}}, 0 {{$t('hotel.rooms')}}</p> -->
                          <p
                            class="mb-0 body-2-2 font-semibold text-white"
                            v-if="getBeCartRoom().length > 0">
                            {{ cartTotalGuest() }}
                            {{ $t('hotel.guests.guests') }},
                            {{ getBeCart().qty.room_rate }}
                            {{
                              $t(
                                'hotel.unit-type.' +
                                  getBeRoomTypeSummaryType() +
                                  '.unit'
                              )
                            }}, {{ cartTotalDate() }} {{ $t('hotel.night') }}
                          </p>
                        </div>
                        <div class="">
                          <div
                            class="bg-light px-3 border-bottom"
                            v-for="(cart_list, index) in getBeCartRoom()">
                            <div class="row no-gutters py-3">
                              <div class="col-7 text-left">
                                <p class="mb-0 body-2 text-12">
                                  {{ cart_list.room_rate.name }}
                                </p>
                                <p class="mb-0 body-2-2 font-semibold text-12">
                                  {{ cart_list.room_rate.room_type.name }}
                                </p>
                                <p class="mb-0 body-3">
                                  {{ $printTotalGuestPerRoom(cart_list) }}
                                </p>
                              </div>
                              <div class="col-5 text-right">
                                <p class="mb-0 body-2-2 text-12 font-semibold">
                                  {{
                                    formatCurrencyCart(
                                      $calculateSubTotalPerRoom(cart_list)
                                    )
                                  }}
                                </p>
                                <p class="mb-0 body-2-2 text-12">
                                  {{ cart_list.qty }}
                                  {{
                                    $t(
                                      'hotel.unit-type.' +
                                        cart_list.room_rate.room_type.type +
                                        '.units'
                                    )
                                  }}
                                </p>
                                <p
                                  class="mb-0 body-2-2 text-10 text-orange underline cursor-pointer"
                                  @click="removeRoomRate(cart_list)">
                                  {{ $t('hotel.remove') }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="p-3 border-b-semi-grey"
                          v-if="isUnderSearchPax()">
                          <div
                            class="w-100 p-3 text-center border"
                            style="
                              background-color: rgb(255, 246, 243);
                              border-color: rgb(254, 207, 184) !important;
                            ">
                            <p class="mb-0 body-2-1">
                              {{ isUnderSearchPax() }}
                            </p>
                          </div>
                        </div>
                        <ProductAdditional page="SEARCH" />
                        <div class="pt-0 px-3 py-3">
                          <div class="row">
                            <div class="col-4">
                              <p class="mb-0 body-2-2 font-semibold text-16">
                                {{ $t('hotel.total') }}
                              </p>
                            </div>
                            <div class="col-8 text-right">
                              <p class="mb-0 body-2-2 font-bold text-18">
                                {{ $formatCurrency(totalPrice) }}
                              </p>
                            </div>
                          </div>
                          <div
                            v-if="
                              getMerchant().use_total_max_guest_restriction &&
                              $isNotEmptyV2(isUnderSearchPax())
                            ">
                            <button
                              v-b-tooltip="`${isUnderSearchPax()}`"
                              class="button-secondary py-2 mt-3 w-100 button-disabled">
                              {{ $t('hotel.reservation') }}
                            </button>
                          </div>
                          <template v-else>
                            <div
                              @click="trackReservationClick()"
                              v-if="getBeCartRoom().length > 0">
                              <router-link
                                :to="'/' + getMerchant().code + '/cart'">
                                <button
                                  class="button-secondary py-2 mt-3 w-100">
                                  {{ $t('hotel.reservation') }}
                                </button>
                              </router-link>
                            </div>
                          </template>
                        </div>
                      </div>
                      <PotentialPromotion
                        v-if="
                          getMerchant().search_room_is_show_promotion_highlight
                        " />

                      <ClaimingReward wrapper_class="mt-5"></ClaimingReward>
                    </div>
                  </div>
                </template>
                <!-- Show More Room Type -->
                <div class="col-9 mt-4" v-if="view_mode == 'list' && show_filter_detail">
                  <div
                    class="px-4 container py-3 bg-light-page-2 rounded-4 cursor-pointer border"
                    @click="clearFilterDetail">
                    <div class="row">
                      <div class="col-8">
                        <div class="row no-gutters">
                          <div class="col-1">
                            <svg
                              width="36"
                              class="position-relative"
                              style="top: 5px"
                              height="36"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g id="Iconly/Bold/Discount">
                                <g id="Discount">
                                  <path
                                    id="Discount_2"
                                    class="fill-primary"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.3991 9.14599L21.1193 9.86599C21.6895 10.426 21.9996 11.186 21.9996 11.986C22.0096 12.786 21.6995 13.547 21.1393 14.116C21.1327 14.1233 21.126 14.1298 21.1193 14.1362C21.116 14.1394 21.1127 14.1427 21.1093 14.146L20.3991 14.856C20.119 15.136 19.9589 15.516 19.9589 15.917V16.946C19.9589 18.606 18.6084 19.957 16.9478 19.957H15.9174C15.5173 19.957 15.1372 20.116 14.8571 20.396L14.1368 21.116C13.5466 21.707 12.7763 21.996 12.006 21.996C11.2357 21.996 10.4655 21.707 9.87525 21.127L9.14498 20.396C8.86488 20.116 8.48474 19.957 8.0846 19.957H7.05423C5.39362 19.957 4.04313 18.606 4.04313 16.946V15.917C4.04313 15.516 3.88308 15.136 3.60298 14.846L2.88271 14.136C1.71229 12.967 1.70229 11.056 2.87271 9.87699L3.60298 9.14599C3.88308 8.86599 4.04313 8.48599 4.04313 8.07599V7.05599C4.04313 5.39599 5.39362 4.04699 7.05423 4.04699H8.0846C8.48474 4.04699 8.86488 3.88599 9.14498 3.60599L9.86524 2.88599C11.0357 1.70699 12.9464 1.70699 14.1268 2.87699L14.8571 3.60599C15.1372 3.88599 15.5173 4.04699 15.9174 4.04699H16.9478C18.6084 4.04699 19.9589 5.39599 19.9589 7.05599V8.08699C19.9589 8.48599 20.119 8.86599 20.3991 9.14599ZM9.42509 15.446C9.66517 15.446 9.88525 15.356 10.0453 15.186L15.1872 10.047C15.5273 9.70699 15.5273 9.14599 15.1872 8.80599C14.8471 8.46699 14.2969 8.46699 13.9567 8.80599L8.81486 13.946C8.47474 14.286 8.47474 14.846 8.81486 15.186C8.97492 15.356 9.195 15.446 9.42509 15.446ZM13.6966 14.566C13.6966 15.056 14.0868 15.446 14.577 15.446C15.0571 15.446 15.4473 15.056 15.4473 14.566C15.4473 14.087 15.0571 13.696 14.577 13.696C14.0868 13.696 13.6966 14.087 13.6966 14.566ZM9.43509 8.55599C9.91526 8.55599 10.3054 8.94599 10.3054 9.42599C10.3054 9.91699 9.91526 10.306 9.43509 10.306C8.95492 10.306 8.55477 9.91699 8.55477 9.42599C8.55477 8.94599 8.95492 8.55599 9.43509 8.55599Z"
                                    fill="#130F26" />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="col-11" style="margin-left: -4px">
                            <p class="mb-1 font-bold text-15 text-semi-dark">
                              Want to get a bigger Promo?
                            </p>
                            <p
                              class="mb-0 font-regular text-13 font-regular text-semi-dark">
                              See our other {{ all_room.length - 1 }} rooms
                              types for promos and different types.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 text-right">
                        <button
                          type="button"
                          class="ga-btn-primary-outline px-5 w-auto radius-0 text-13 py-12px rounded-4 cursor-pointer delay"
                          style="background-color: #faf9f8">
                          Show All Promo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Room Detail -->
                <transition name="fade">
                  <template v-if="detail_room">
                    <roomTypeDetail
                      @detailRoom="detailRoom()"
                      @handlePopupFilter="handlePopupFilter"
                      :detail_room="detail_room"
                      :detail_room_type="detail_room_type"
                      :popup_active="popup_active"
                      :is_active="is_active">
                    </roomTypeDetail>
                  </template>
                </transition>
              </div>
            </template>
          </div>
        </div>
      </b-skeleton-wrapper>
    </template>

    <!-- ADDITIONAL PRODUCT -->
    <template
      v-if="
        !iActiveHotelModuleRoom() &&
        getMerchant().additional_appearance === 'SEARCH_ROOM'
      ">
      <AdditionalModule />
    </template>

    <!-- LOCATION & NEARBY -->
    <div class="ga-container fluid mb-5 pt-4">
      <BeLocationNearby />
    </div>

    <!-- Footer -->
    <Footer></Footer>

    <!-- PopUp Background -->
    <transition name="fade">
      <template v-if="popup_active">
        <PopUpBackground
          @handlePopupFilter="handlePopupFilter"
          :popup_active="popup_active"
          :data="popup_active_true"></PopUpBackground>
      </template>
    </transition>

    <GeneralLanguageCurrency :showPopup="showLanguagePopup" @togglePopup="toggleShowLanguagePopup" />

    <popupConfirmation
      stack-on-top
      :show="popupConfirmation.show"
      :title="popupConfirmation.title"
      :subtitle="popupConfirmation.subtitle"
      @hide="setConfirmationModal"
      @apply="confirmCartResetOnFilterChange" />

    <!-- ROOM TYPE PICKED FROM THE DIGITAL MAP -->
    <BeMapRoomModalLegacy
      :room-type-id="mapRoomTypeId"
      :room-type-name="mapRoomTypeName"
      :search-params="map_search_params"
      :get-room-avlb="getRoomAvlb"
      :header-scroll="header_scroll"
      :rt-hightlight-index="is_room_rate_highlight"
      :room-rate-highlight="roomRateHighlight"
      :is-booking-dropdown="is_booking_dropdown"
      :show-rate="show_rate"
      :show-rate-breakdown="show_rate_breakdown"
      :is-active="is_active"
      :format-date="formatDate"
      :total-rate-breakdown="totalRateBreakdown"
      :popup-active="popup_active"
      @close="closeMapRoomType"
      @select-date="applyFlexibleDate"
      @room_type_detail="detailRoom"
      @toggleRateBreakdown="toggleRateBreakdown"
      @toggleBookingRate="toggleBookingRate"
      @toggleBookingRateCart="toggleBookingRateCart"
      @handlePopupFilter="handlePopupFilter" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { get } from '@/services/index.js';
import Flickity from 'vue-flickity';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
// import 'vue-range-component/dist/vue-range-slider.css'
// import VueRangeSlider from 'vue-range-component'
import roomTypeDetail from '@/components/hotel/be/desktop/roomTypeDetail';
import BeRoomDesktop from '@/components/hotel/be/desktop/room';
import BeDigitalMap from '@/components/hotel/be/v3/BeDigitalMap.vue';
import BeMapRoomModalLegacy from '@/components/hotel/be/v3/BeMapRoomModalLegacy.vue';
import {
  pushHistoryStep,
  releaseHistoryStep,
  abandonHistorySteps,
} from '@/utils/historyStep.js';
import { resolveDefaultViewMode } from '@/utils/beViewMode.js';
import CartDesktop from '@/components/hotel/be/desktop/cart';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import moment from 'moment';
import {
  formatCurrency,
  inputCustomOnly,
  customFormatDateTime,
  isSameBeFilter,
} from '@/utils/index.js';
import Footer from '@/components/hotel/Footer';
import Facilities from '@/components/hotel/facilities';
import CalendarRoom from '@/components/hotel/be/CalendarRoom';
import TopNavbar from '@/components/hotel/be/desktop/navbar';
import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
import PromoCode from '@/components/hotel/be/PromoCode';
import PotentialPromotion from '@/components/hotel/be/PotentialPromotion.vue';
import FlexibleDateAlternatives from '@/components/hotel/be/FlexibleDateAlternatives.vue';
import BeMembershipPromoLoginBanner from '@/components/hotel/be/BeMembershipPromoLoginBanner.vue';
import HotelProductTab from '../../../components/hotel/HotelProductTab.vue';
import AdditionalModule from '../../../components/hotel/be/AdditionalModule.vue';
import SearchPreviewCart from '../../../components/hotel/be/SearchPreviewCart.vue';
import SearchRoomHeader from '../../../components/hotel/be/SearchRoomHeader.vue';
import HotelRoomFilter from '../../../components/hotel/be/HotelRoomFilter.vue';
import GeneralLanguageCurrency from '../../../components/general/GeneralLanguageCurrency.vue';
import ProductAdditional from '@/components/hotel/be/additionalService/ProductCart.vue';
import popupConfirmation from '../../../components/general/popupConfirmation.vue';
import { trackEvent } from '../../../utils/analytics';
import BeLocationNearby from '@/components/hotel/be/v3/BeLocationNearby.vue';
import BePromotionFilterChip from '@/components/hotel/be/v3/BePromotionFilterChip.vue';
import { withPromotionFilter } from '@/utils/bePromotionFilter.js';


export default {
  props: ['reload', 'promoCodePopup'],
  components: {
    Flickity,
    Facilities,
    Datepicker,
    DateRangePicker,
    Footer,
    BeLocationNearby,
    roomTypeDetail,
    BeRoomDesktop,
    CartDesktop,
    PopUpBackground,
    CalendarRoom,
    TopNavbar,
    ClaimingReward,
    PromoCode,
    PotentialPromotion,
    FlexibleDateAlternatives,
    BeMembershipPromoLoginBanner,
    HotelProductTab,
    AdditionalModule,
    SearchPreviewCart,
    SearchRoomHeader,
    HotelRoomFilter,
    GeneralLanguageCurrency,
    ProductAdditional,
    BeDigitalMap,
    BeMapRoomModalLegacy,
    popupConfirmation,
    BePromotionFilterChip
  },
  data() {
    return {
      error: '',
      message: '',
      header_image: '',
      popup_active: '',
      popup_active_true: false,
      header_scroll: true,
      scrollPosition: null,
      minDate: moment().subtract(1, 'd').toDate(),
      search_filter: {
        date: {},
        guest: {},
        promo_code: '',
        price: '',
        sort_by: '',
        use_filter_price: false,
      },
      date_avlb_filter: [],
      date_month_active: [],
      is_active: '',
      search_filter_date: {
        startDate: '',
        endDate: '',
      },
      search_filter_guest: {
        adult: '',
        child: '',
        infant: '',
      },
      search_filter_promo_code: '',
      promoCodeWarningMessage: '',
      promoCodeValidDates: null,
      promoCodeErrorType: '',
      range_price: [0, 0],
      range_price_active: '',
      popup_filter_price: '',
      is_range_price: {
        min: false,
        max: false,
        use_min: false,
        use_max: false,
      },
      temp_range_price: {
        price: [0, 0],
        is_use: [false, false],
      },
      filter_active: false,
      category_list: [
        {
          id: 'room_type',
          slug: 'room_type',
          name: this.$t('hotel.rooms-type'),
        },
        {
          id: 'promotion',
          slug: 'promotion',
          name: this.$t('hotel.promotions'),
        },
        {
          id: 'packages',
          slug: 'packages',
          name: this.$t('hotel.packages'),
        },
      ],
      is_load: false,
      room: [],
      is_booking_dropdown: false,
      show_rate: false,
      show_rate_breakdown: false,
      is_booking_rate_cart: [],
      detail_room: '',
      detail_room_type: '',
      merchant_community: {
        list: [],
        selected: {},
      },
      all_room: '',
      filter_key: 0,
      lastSearchedFilter: null,
      pendingCartReset: null,
      popupConfirmation: {
        show: false,
        title: '',
        subtitle: '',
      },
      showLanguagePopup: false,
      view_mode: 'list',
      map_list: [],
      is_map_checking: true,
      active_root_map_id: null,
      map_room_type_ref: null,
      map_search_params: {},
      flexible_dates: [],
      flexible_dates_loading: true,
    };
  },
  watch: {
    /* An open map popup was given the params of the dates it opened on, and the
       search flow commits the new ones only after its promo-code check settles.
       Reacting to the committed dates rebuilds those params whenever they land,
       so the popup reloads the room the guest is looking at instead of holding
       stale rates. */
    beFilterDateSignature() {
      if (this.map_room_type_ref) this.map_search_params = this.getParamsRoomList(false);
    },
    header_scroll() {
      this.header_scroll2 = this.header_scroll;
    },
    base_rate: {
      deep: true,
      handler() {
        let copied_data_price = Object.assign({}, this.getBePrice());
        this.range_price[0] = Math.ceil(
          copied_data_price[0] * this.base_rate.a
        );
        this.range_price[1] = Math.ceil(
          copied_data_price[1] * this.base_rate.a
        );
      },
    },
    reload() {
      this.reloadAfterApplyPromo();
    },
    selectedPromotion() {
      if(!this.is_load){
        const validatePromotion = this.$isNotEmptyV2(this.selectedPromotion);
        this.loadSearchByRoomType(validatePromotion );
      }
    },
  },
  created() {
    /* Plain instance properties: a handle on the browser entry that mirrors an
       open layer is bookkeeping, not view state. */
    this.map_room_type_step = null;
    this.room_type_detail_step = null;
    this.view_mode = resolveDefaultViewMode(this.getMerchant());
    this.$validateActiveReward('HOTEL_PROMOTION');
    this.changeFilterDate();
  },
  computed: {
    showSpecificFilter() {
      return this.$isNotEmptyV2(this.getBeFilterDetail().data);
    },
    isAllRoomsSoldOut() {
      if (!this.room || this.room.length == 0) return false;
      return this.room.every((type) =>
        type.room_rate.every(
          (rate) => !rate.bookable || this.$roomAvbl(rate.room_type.id, rate.id) <= 0
        )
      );
    },
    logo() {
      return this.getMerchant().image_orientation;
    },
    show_filter_detail() {
      return Object.keys(this.getBeFilterDetail().data).length > 0
        ? true
        : false;
    },
    showLanguageMenu(){
      return this.getMerchant().language && this.getMerchant().language.length > 1
    },
    base_rate() {
      return this.getBaseRate();
    },
    is_room_rate_highlight() {
      let rt_index = -1;
      this.room.forEach((item, index) => {
        let room_avlb_index = this.getBeRoomAvbl().findIndex(
          (x) => x.id == item.id
        );
        if (room_avlb_index != -1) {
          let avlb =
            this.getBeRoomAvbl()[room_avlb_index].original_availability;
          if (rt_index == -1 && avlb > 0) {
            rt_index = index;
          }
        }
      });
      return rt_index;
    },
    roomRateHighlight() {
      if (!this.room) return { roomTypeIndex: -1, roomRateIndex: -1 };

      let roomRateIndex = -1;
      let roomTypeIndex = this.room.findIndex((room) => {
        const availableRoom = this.getBeRoomAvbl().find(
          (avbl) => avbl.id === room.id
        );
        let roomRateIndexSelected = room.room_rate.findIndex(
          (roomRate) => roomRate.bookable
        );
        let validRoomType =
          availableRoom && availableRoom.original_availability > 0;
        let validRoomRate = roomRateIndexSelected != -1 && roomRateIndex == -1;
        if (validRoomType && validRoomRate) {
          roomRateIndex = roomRateIndexSelected;
          return true;
        }
      });

      return { roomTypeIndex, roomRateIndex };
    },
    selectedPromotion() {
      const promotion = this.getSelectedPromotion();
      if (!promotion) return '';
      return promotion.id;
    },
    publicPromoCodeWithBanner() {
      if (this.$isEmpty(this.promoCodePopup)) return [];

      return this.promoCodePopup.filter((promo) =>
        this.$isNotEmptyV2(promo.popup_image)
      );
    },
    totalGreenTax(){
      const { deposit, pay_later } = this.$greenTaxes();
      return deposit + pay_later;
    },
    totalRoomPrice(){
      const { search_room_is_show_tax_fee_note: showTaxes } = this.getMerchant();
      return showTaxes ? this.getBeRoomTotal() + this.totalGreenTax : this.getBeRoomTotal();
    },
    totalPrice() {
      let total = this.totalRoomPrice;

      const { additional_appearance } = this.getMerchant();
      if (additional_appearance === 'SEARCH_ROOM') {
        const totalAdditionalService =
          this.getBeAddtServiceSubTotal() + this.$totalAddtServiceModule();

        total += totalAdditionalService;
      }

      return total;
    },
    rootMapList() {
      const roots = Array.isArray(this.map_list)
        ? this.map_list.filter((m) => m.is_root)
        : [];
      // if no map is flagged root, every map the list endpoint returns is a
      // top-level one
      return roots.length > 0 ? roots : this.map_list;
    },
    // config may default view_mode to 'map' before loadMapList confirms one
    // exists -- hold off rendering BeDigitalMap until that check settles
    showMapArea() {
      return this.view_mode == 'map' && !this.is_map_checking;
    },
    mapRoomTypeId() {
      return this.map_room_type_ref ? this.map_room_type_ref.id : null;
    },
    mapRoomTypeName() {
      return this.map_room_type_ref ? this.map_room_type_ref.name : '';
    },
    beFilterDateSignature() {
      const { check_in, check_out } = this.getBeFilter().date;
      return `${this.$formatDateApi(check_in)}_${this.$formatDateApi(check_out)}`;
    },
  },
  mounted() {
    if (this.$showCommunity()) {
      this.loadMerchantList();
    }
    this.loadMapList();
    this.changeFilterDate();
    this.loadFirstDateFilter();
    this.search_filter = JSON.parse(JSON.stringify(this.getBeFilter()));
    this.lastSearchedFilter = JSON.parse(JSON.stringify(this.getBeFilter()));

    // check price
    let copied_data_price = Object.assign({}, this.getBePrice());
    if (this.getBePrice()[0] > 0) {
      this.range_price[0] = copied_data_price[0];
      this.is_range_price.use_min = true;
    }
    if (this.getBePrice()[1] > 0) {
      this.range_price[1] = copied_data_price[1];
      this.is_range_price.use_max = true;
    }
    this.range_price_active =
      this.is_range_price.use_min || this.is_range_price.use_max ? true : false;

    this.is_active = JSON.parse(JSON.stringify(this.getBeSortBy()));
    this.vuexSearchFilter();
    this.loadSearchByRoomType();
    window.addEventListener('scroll', this.updateScroll);
    document.getElementById('hotel-room').scrollIntoView({
      behavior: 'smooth',
    });
    // this.toggleFilterPriceActive()
    if (
      moment(this.$startDate(this.search_filter_date.endDate)).isSameOrBefore(
        this.$startDate(this.search_filter_date.startDate)
      )
    ) {
      this.toggleBeCek();
    }
    this.header_image = this.getMerchant().booking_engine_hero_banner;
  },
  beforeDestroy() {
    abandonHistorySteps();
  },
  methods: {
    ...mapGetters([
      'getMerchant',
      'getBeFilter',
      'getBePrice',
      'getBeSortBy',
      'getBeCart',
      'getBeCartRoom',
      'getBeRoomTotal',
      'getCurrency',
      'getBaseRate',
      'getCurrentLanguage',
      'getBeFilterDetail',
      'getBeRoomAvbl',
      'getBeRoomTypeSummaryType',
      'isNotLogin',
      'getCurrentUser',
      'getMembershipRewardApplied',
      'isUnderSearchPax',
      'getMembershipReferral',
      'getSelectedPromotion',
      'getBePromotionFilterId',
      'iActiveHotelModuleRoom',
      'getBeAddtServiceSubTotal'
    ]),
    ...mapMutations([
      'setBeFilter',
      'setBePrice',
      'setBeSortBy',
      'beRemoveRoomRate',
      'BeManipulateRoomRate',
      'setBeRoomAvbl',
      'changeBeRoomAvbl',
      'setBeFilterDetail',
      'setActiveRoute',
      'setMembershipRewardApplied',
      'resetSelectedPromotion',
      'resetBePromotionFilter',
      'setSpecificBeFilter'
    ]),
    getRoomAvlb(room_type_id) {
      let room_avlb_index = this.getBeRoomAvbl().findIndex(
        (x) => x.id == room_type_id
      );
      let avlb = 0;
      if (room_avlb_index != -1) {
        avlb = this.getBeRoomAvbl()[room_avlb_index].original_availability;
      }
      return avlb;
    },
    toggleMapView(mode) {
      this.view_mode = mode;
    },
    loadMapList() {
      get('CORE_HOTEL', 'merchant-booking-map-list', {
        merchant_id: this.getMerchant().id,
      })
        .then((response) => {
          let res = response.data;
          if (res.success && this.$isNotEmptyV2(res.data)) {
            this.map_list = res.data;
          }
          this.reconcileViewModeAfterMapCheck();
        })
        .catch(() => {
          this.reconcileViewModeAfterMapCheck();
        });
    },
    // config may resolve to 'map' before the map-list check confirms one
    // exists; without a map there is also no toggle to escape 'map' mode, so
    // fall back once the check settles (success-but-empty, or a failed request)
    reconcileViewModeAfterMapCheck() {
      this.is_map_checking = false;
      if (this.view_mode == 'map' && this.map_list.length == 0) {
        this.view_mode = 'list';
      }
    },
    openMapRoomType(roomTypeRef) {
      this.map_search_params = this.getParamsRoomList(false);
      this.map_room_type_ref = roomTypeRef;
      this.map_room_type_step = pushHistoryStep(this.dismissMapRoomType);
    },
    /* Browser Back: its history entry is already consumed, so drop the handle
       first and let the normal close path run without rewinding again. */
    dismissMapRoomType() {
      this.map_room_type_step = null;
      this.closeMapRoomType();
    },
    closeMapRoomType() {
      if (!this.map_room_type_ref) return;
      const step = this.map_room_type_step;
      this.map_room_type_step = null;
      this.map_room_type_ref = null;
      /* Rate Detail / Book Now inside the popup raise the page-level backdrop
         and leave show_rate* set. The popup owns the only row those flags refer
         to, so closing it has to clear them or the backdrop outlives it. */
      this.handlePopupFilter(false);
      // also rewinds past a room type detail stacked above, closing it too
      if (step) releaseHistoryStep(step);
    },
    toggleShowLanguagePopup(show = false) {
      this.showLanguagePopup = show;
    },
    formatDateNumber(value) {
      return moment(value).format('D');
    },
    formatCurrencyCompact(value) {
      let formatter = Intl.NumberFormat('en', { notation: 'compact' });
      return formatter.format(value);
    },
    formatCurrency(value, no_base_rate = false) {
      return formatCurrency(
        value,
        no_base_rate,
        true,
        this.getCurrency(),
        this.getBaseRate().b
      );
    },
    applyDateFilter(date) {
      this.search_filter_date = date;
    },
    printPricePerDay(date) {
      let month = moment(date).format('MM');
      let dmy = moment(date).format('YYYY-MM-DD');
      let month_index = this.date_avlb_filter.findIndex(
        (x) => x.month == month
      );
      if (month_index != -1) {
        let date_index = this.date_avlb_filter[month_index].data.findIndex(
          (y) => y.date == dmy
        );
        if (date_index != -1) {
          return this.date_avlb_filter[month_index].data[date_index]
            .lower_price;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    changeMonth(monthDate, index) {
      this.initialDateFilter(monthDate);
      let sameData = this.date_avlb_filter.filter((x) =>
        this.date_month_active.includes(x.month)
      );
      this.date_avlb_filter = sameData;
      if (sameData.length == 0) {
        this.loadRoomAvlbByDate(monthDate);
        let my = moment(monthDate).add(1, 'M').format('YYYY-MM');
        let dmy = moment(`${my}-1`, 'YYYY-MM-D').toDate();
        this.loadRoomAvlbByDate(dmy);
      } else if (sameData.length == 1) {
        if (sameData[0].month == this.date_month_active[0]) {
          let my = moment(monthDate).add(1, 'M').format('YYYY-MM');
          let dmy = moment(`${my}-1`, 'YYYY-MM-D').toDate();
          this.loadRoomAvlbByDate(dmy);
        } else {
          this.loadRoomAvlbByDate(monthDate);
        }
      }
    },
    dateAvlb(classes, date) {
      if (!classes.off) {
        let month = moment(date).format('MM');
        let dmy = moment(date).format('YYYY-MM-DD');
        let month_index = this.date_avlb_filter.findIndex(
          (x) => x.month == month
        );
        if (month_index != -1) {
          let date_index = this.date_avlb_filter[month_index].data.findIndex(
            (y) => y.date == dmy
          );
          if (date_index != -1) {
            classes.off =
              this.date_avlb_filter[month_index].data[date_index].availability <
              1;
          }
        }
      }
      // console.log("classes : ",classes)
      // console.log("date : ",date)
      // console.log("===================")
      return classes;
    },
    initialDateFilter(date) {
      this.date_month_active = [];
      this.date_month_active.push(moment(date).format('MM'));
      this.date_month_active.push(moment(date).add(1, 'M').format('MM'));
    },
    loadFirstDateFilter() {
      this.initialDateFilter(this.getBeFilter().date.check_in);
      // this.loadRoomAvlbByDate(this.getBeFilter().date.check_in)
      let my = moment(this.getBeFilter().date.check_in)
        .add(1, 'M')
        .format('YYYY-MM');
      let dmy = moment(`${my}-1`, 'YYYY-MM-D').toDate();
      // this.loadRoomAvlbByDate(dmy)
    },
    loadRoomAvlbByDate(date) {
      let start_date = date;
      let today = moment().subtract(1, 'd').toDate();
      for (let i = 1; i <= moment(date).endOf('month').format('D'); i++) {
        let my = moment(date).format('YYYY-MM');
        let dmy = moment(`${my}-${i}`, 'YYYY-MM-D').toDate();
        if (moment(today).isBefore(dmy)) {
          start_date = dmy;
          break;
        }
      }

      let param = {
        merchant_id: this.getMerchant().id,
        start_date: moment(start_date).format('YYYY-MM-DD'),
        end_date: moment(date).endOf('month').format('YYYY-MM-DD'),
        adult: this.search_filter.guest.adult,
        child: this.search_filter.guest.child,
        infant: this.search_filter.guest.infant,
        use_promotion_combine: true,
      };
      get('CORE_HOTEL', 'search-availability', param).then((response) => {
        let res = response.data;
        if (res.success) {
          let result = {
            month: moment(param.start_date, 'YYYY-MM-DD').format('MM'),
            data: res.data,
          };

          if (
            this.date_avlb_filter.length == 0 ||
            this.date_avlb_filter.length == 1
          ) {
            this.date_avlb_filter.push(result);
          } else {
            this.date_avlb_filter.forEach((month_avlb, index) => {
              let date_avlb_check = this.date_month_active.findIndex(
                (x) => x == month_avlb.month
              );
              if (date_avlb_check == -1) {
                this.date_avlb_filter.splice(index, 1);
              } else {
              }
            });
            this.date_avlb_filter.push(result);
          }
        }
      });
    },
    inputNumberDotCommaOnly($event) {
      inputCustomOnly('number_dot_comma', $event);
    },
    trackSearchClick() {
      this.$trackRoomSearch();
      this.hitGogleAnalytics('search');
    },
    trackReservationClick() {
      this.$track('add_to_cart');
      this.hitGogleAnalytics('goto_cart');
    },
    hitGogleAnalytics(event) {
      if(this.$hasGoogleTag()){
        this.$gtag('event',event, { method: 'Google' });
      }
    },
    formatCurrencyCart(value) {
      return formatCurrency(value);
    },
    formatDate(date) {
      return customFormatDateTime(date, null, 'ddd, DD MMM YYYY');
    },
    displayToday(date) {
      if (moment().isSame(moment(date), 'day'))
        return this.$t('merchant.today');
      return customFormatDateTime(date, null, 'dddd');
    },
    clearFilterDetail() {
      let params = {
        type: 'room_type',
        data: {},
      };
      this.setBeFilterDetail(params);
      this.loadSearchByRoomType();
    },
    clearPromotionFilter() {
      this.resetBePromotionFilter();
      this.closeMapRoomType();
      this.loadSearchByRoomType();
    },
    async toggleBeSearch({ dropInvalidPromoCode = false } = {}) {
      // Sinkronisasi data guest & promo dari local state ke utama
      this.search_filter = this.$deepCopy(this.getBeFilter());
      this.search_filter.guest = { ...this.search_filter_guest };
      this.search_filter.promo_code = this.search_filter_promo_code;

      const { startDate, endDate } = this.search_filter_date;

      // Jika start-date & end-date sama atau terbalik, otomatis perbaiki range-nya
      if (moment(endDate).isSameOrBefore(startDate)) {
        this.toggleBeCek();
      } else {
        this.search_filter.date = { check_in: startDate, check_out: endDate };
      }

      this.promoCodeWarningMessage = '';
      this.promoCodeValidDates = null;
      this.promoCodeErrorType = '';

      if (this.$isNotEmptyV2(this.search_filter_promo_code)) {
        const dateRange = await this.checkingPromoCode().catch((error) => {
          if (!dropInvalidPromoCode) throw error;
          this.clearSearchPromoCode();
          return null;
        });
        if (dateRange) {
          if (dateRange.min_night_error) {
            // Error: total malam kurang dari minimum night promo code
            this.promoCodeErrorType = 'min_night_error';
            this.promoCodeWarningMessage = `Minimum stay for this promo code is ${dateRange.min_night} night(s). You selected ${dateRange.total_nights} night(s).`;
            this.promoCodeValidDates = dateRange.startDate && dateRange.endDate ? { startDate: dateRange.startDate, endDate: dateRange.endDate } : null;
          } else {
            this.promoCodeErrorType = 'date_not_available';
            let availableDatesText = '';
            if (dateRange.stay_date && dateRange.stay_date.length > 0) {
              availableDatesText = dateRange.stay_date.map(d => `${moment(d.start_date, 'YYYY-MM-DD').format('DD MMM YYYY')} - ${moment(d.end_date, 'YYYY-MM-DD').format('DD MMM YYYY')}`).join(', ');
            } else {
              availableDatesText = `${moment(dateRange.startDate).format('DD MMM YYYY')} - ${moment(dateRange.endDate).format('DD MMM YYYY')}`;
            }
            this.promoCodeWarningMessage = `${availableDatesText}`;
            this.promoCodeValidDates = { startDate: dateRange.startDate, endDate: dateRange.endDate };
          }
        }
      }

      this.scrollIntoView();
      if (this.search_filter_promo_code) {
        this.setMembershipRewardApplied({});
      }

      trackEvent('search_room', this.search_filter);
      this.loadSearchByRoomType();
      this.is_booking_rate_cart = [];
    },
    async checkingPromoCode() {
      try {
        const apiParams = {
          merchant_id: this.getMerchant().id,
          promo_code: this.search_filter_promo_code,
        };

        const apiResponse = await get(
          'CORE_HOTEL',
          'promocode-detail',
          apiParams
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);

        if (data) {
          if(data.stay_date && data.stay_date.length > 0){
            let availableDates = [];
            const today = moment().startOf('day');

            data.stay_date.forEach(stay => {
              let current = moment(stay.start_date, 'YYYY-MM-DD').startOf('day');
              let end = moment(stay.end_date, 'YYYY-MM-DD').startOf('day');

              if (current.isBefore(today)) current = today.clone();

              while (current.isSameOrBefore(end)) {
                const dayMap = [
                  'stay_sunday',
                  'stay_monday',
                  'stay_tuesday',
                  'stay_wednesday',
                  'stay_thursday',
                  'stay_friday',
                  'stay_saturday'
                ];
                const dayName = dayMap[current.day()];

                const isDayValid = stay[dayName] !== false && stay[dayName] !== 0;

                if (isDayValid) {
                  const minNight = data.min_night || 1;
                  availableDates.push({ date: current.clone(), minNight });
                }
                current.add(1, 'day');
              }
            });

            if (availableDates.length > 0) {
              const currentCheckIn = moment(this.search_filter_date.startDate).startOf('day');
              const currentCheckOut = moment(this.search_filter_date.endDate).startOf('day');

              const availableDateStrings = availableDates.map(o => o.date.format('YYYY-MM-DD'));

              const globalMinNight = data.min_night || 1;

              const isRangeAvailable = (start, lengthNights) => {
                if (lengthNights <= 0) return false;
                let temp = start.clone();
                for (let i = 0; i < lengthNights; i++) {
                  if (!availableDateStrings.includes(temp.format('YYYY-MM-DD'))) return false;
                  temp.add(1, 'day');
                }
                return true;
              };

              availableDates.sort((a, b) => a.date.valueOf() - b.date.valueOf());
              let fallbackCheckIn = availableDates[0].date.clone();
              let fallbackCheckOut = fallbackCheckIn.clone().add(globalMinNight, 'days');

              for (let i = 0; i < availableDates.length; i++) {
                const candidate = availableDates[i].date;
                if (isRangeAvailable(candidate, globalMinNight)) {
                  fallbackCheckIn = candidate.clone();
                  fallbackCheckOut = candidate.clone().add(globalMinNight, 'days');
                  break;
                }
              }

              const currentNights = currentCheckOut.diff(currentCheckIn, 'days');
              const isCurrentDateValid = isRangeAvailable(currentCheckIn, currentNights);

              if (isCurrentDateValid) {
                console.log('date valid (RoomDesktop)');
                if (currentNights < globalMinNight) {
                  const newCheckOut = currentCheckIn.clone().add(globalMinNight, 'days');

                  if (isRangeAvailable(currentCheckIn, globalMinNight)) {
                    return {
                      startDate: currentCheckIn.toDate(),
                      endDate: newCheckOut.toDate(),
                      stay_date: data.stay_date,
                      min_night_error: true,
                      min_night: globalMinNight,
                      total_nights: currentNights
                    };
                  } else {
                    return {
                      startDate: fallbackCheckIn.toDate(),
                      endDate: fallbackCheckOut.toDate(),
                      stay_date: data.stay_date
                    };
                  }
                } else {
                  return null;
                }
              } else {
                console.log('tidak avb (RoomDesktop)');
                return {
                  startDate: fallbackCheckIn.toDate(),
                  endDate: fallbackCheckOut.toDate(),
                  stay_date: data.stay_date
                };
              }
            }
          }

          // Validasi: jika total malam yang dipilih kurang dari minimum night promo code
          const globalMinNight = data.min_night || 1;
          const currentCheckIn = moment(this.search_filter_date.startDate).startOf('day');
          const currentCheckOut = moment(this.search_filter_date.endDate).startOf('day');
          const totalNights = currentCheckOut.diff(currentCheckIn, 'days');

          if (totalNights < globalMinNight) {
            return {
              min_night_error: true,
              min_night: globalMinNight,
              total_nights: totalNights,
              startDate: currentCheckIn.toDate(),
              endDate: moment(currentCheckIn).add(globalMinNight, 'days').toDate(),
            };
          }
        }

        return null;
      } catch (error) {
        console.log('ERROR in checkingPromoCode() RoomDesktop: ', error.message);
        throw error;
      }
    },
    applyValidPromoDates() {
      if (this.promoCodeValidDates) {
        this.search_filter_date.startDate = this.promoCodeValidDates.startDate;
        this.search_filter_date.endDate = this.promoCodeValidDates.endDate;
        this.search_filter.date = {
          check_in: this.promoCodeValidDates.startDate,
          check_out: this.promoCodeValidDates.endDate,
        };
        this.toggleBeSearch();
      }
    },
    applyFlexibleDate({ check_in_date, check_out_date }) {
      this.search_filter_date.startDate = check_in_date;
      this.search_filter_date.endDate = check_out_date;
      this.search_filter.date = { check_in: check_in_date, check_out: check_out_date };
      // a wrong code carried in from the website plugin would fail the suggested dates too
      this.toggleBeSearch({ dropInvalidPromoCode: true });
    },
    clearSearchPromoCode() {
      this.search_filter_promo_code = '';
      this.search_filter.promo_code = '';
    },
    toggleBeCek() {
      // Perbaiki tanggal check-out berdasarkan default night
      const correctedEndDate = moment(this.search_filter_date.startDate)
        .add(this.$defaultFilterBE('night'), 'd')
        .toDate();

      this.search_filter_date.endDate = correctedEndDate;

      this.search_filter.date = {
        check_in: this.search_filter_date.startDate,
        check_out: correctedEndDate,
      };

      this.setBeFilter(this.search_filter);
    },
    vuexSearchFilter() {
      this.search_filter_guest.adult = this.search_filter.guest.adult;
      this.search_filter_guest.child = this.search_filter.guest.child;
      this.search_filter_guest.infant = this.search_filter.guest.infant;
      this.search_filter_promo_code = this.search_filter.promo_code;
    },
    reloadAfterApplyPromo() {
      this.search_filter = JSON.parse(JSON.stringify(this.getBeFilter()));
      this.vuexSearchFilter();
      this.scrollIntoView();
      this.loadSearchByRoomType();
      this.is_booking_rate_cart = [];
      this.toggleResertCart();
    },
    toggleCounter(data, category) {
      if (data == 'plus' && category == 'adult') {
        this.search_filter_guest.adult++;
      } else if (data == 'min' && category == 'adult') {
        this.search_filter_guest.adult--;
        if (this.search_filter_guest.adult <= 0) {
          this.search_filter_guest.adult = 0;
        }
      } else if (data == 'plus' && category == 'child') {
        this.search_filter_guest.child++;
      } else if (data == 'min' && category == 'child') {
        this.search_filter_guest.child--;
        if (this.search_filter_guest.child <= 0) {
          this.search_filter_guest.child = 0;
        }
      } else if (data == 'plus' && category == 'infant') {
        this.search_filter_guest.infant++;
      } else if (data == 'min' && category == 'infant') {
        this.search_filter_guest.infant--;
        if (this.search_filter_guest.infant <= 0) {
          this.search_filter_guest.infant = 0;
        }
      }
    },
    changeFilterDate() {
      this.search_filter = JSON.parse(JSON.stringify(this.getBeFilter()));
      this.search_filter_date.startDate = this.search_filter.date.check_in;
      this.search_filter_date.endDate = this.search_filter.date.check_out;
      let today = this.$startDate();
      if (
        moment(this.$startDate(this.search_filter.date.check_in)).isBefore(
          today
        )
      ) {
        this.search_filter.date.check_in = new Date();
        this.search_filter_date.startDate = this.search_filter.date.check_in;
        this.search_filter.date.check_in = moment(
          this.search_filter.date.check_in
        ).format('YYYY-MM-DD');
        this.search_filter.date.check_out = moment(
          this.search_filter.date.check_out
        ).format('YYYY-MM-DD');
        if (
          moment(
            this.$startDate(this.search_filter.date.check_out)
          ).isSameOrBefore(this.$startDate(this.search_filter.date.check_in))
        ) {
          this.search_filter.date.check_out = moment(
            this.search_filter.date.check_in
          )
            .add(this.$defaultFilterBE('night'), 'd')
            .toDate();
          this.search_filter_date.endDate = this.search_filter.date.check_out;
          this.setBeFilter(this.search_filter);
        } else {
          this.setBeFilter(this.search_filter);
        }
        this.setBeFilter(this.search_filter);
      }
    },
    toggleFilterActive(data) {
      if (this.filter_active == data) {
        if (data == 'filter-price') {
          this.temp_range_price = {
            price: [0, 0],
            is_use: [false, false],
          };
        }
        this.filter_active = false;
      } else {
        if (data == 'filter-price') {
          let copied_data_price = Object.assign({}, this.range_price);
          let copied_data_price_use = Object.assign({}, this.is_range_price);
          this.temp_range_price = {
            price: copied_data_price,
            is_use: [
              copied_data_price_use.use_min,
              copied_data_price_use.use_max,
            ],
          };
        }
        this.filter_active = data;
      }
      this.popup_active = 'search';
    },
    handlePopupFilter(data) {
      if (data == false) {
        this.popup_active = false;
        this.filter_active = false;
        this.show_rate = false;
        this.show_rate_breakdown = false;
        this.is_booking_dropdown = false;
        this.popup_active_true = false;
      } else {
        this.popup_active = data;
      }
    },
    toggleFilterPrice(data) {
      if (data == 'add') {
        if (this.is_range_price.use_min && this.range_price[0] == 0) {
          this.is_range_price.use_min = false;
        }
        if (!this.is_range_price.use_min && this.range_price[0] > 0) {
          this.range_price[0] = 0;
        }
        if (this.is_range_price.use_max && this.range_price[1] == 0) {
          this.is_range_price.use_max = false;
        }
        if (!this.is_range_price.use_max && this.range_price[1] > 0) {
          this.range_price[1] = 0;
        }

        let local_price = [
          this.range_price[0] * this.getBaseRate().b,
          this.range_price[1] * this.getBaseRate().b,
        ];
        this.setBePrice(local_price);
        this.loadSearchByRoomType();
        this.filter_active = false;
        this.scrollIntoView();
        this.range_price_active =
          this.is_range_price.use_min || this.is_range_price.use_max
            ? true
            : false;
      } else if (data == 'cancel') {
        this.refillDataFilterPrice();
        this.filter_active = false;
      } else if (data == 'delete') {
        this.range_price_active = false;
        this.popup_filter_price = false;
        // this.range_price[0] = this.min
        // this.range_price[1] = this.max
        this.is_range_price.use_min = false;
        this.is_range_price.use_max = false;
        this.range_price = [0, 0];
        this.setBePrice(this.range_price);
        this.loadSearchByRoomType();
        this.scrollIntoView();
      }
      this.popup_active = false;
      this.temp_range_price = {
        price: [0, 0],
        is_use: [false, false],
      };
    },
    refillDataFilterPrice() {
      this.range_price = this.temp_range_price.price;
      this.is_range_price.use_min =
        this.range_price[0] > 0 ? this.temp_range_price.is_use[0] : false;
      this.is_range_price.use_max =
        this.range_price[1] > 0 ? this.temp_range_price.is_use[1] : false;
      this.range_price_active =
        this.is_range_price.use_min || this.is_range_price.use_max
          ? true
          : false;
    },
    // toggleFilterPriceActive(){
    //   if (this.range_price[0] > this.min || this.range_price[1] < this.max ) {
    //     this.range_price_active = true
    //   }else{
    //     this.range_price_active = false
    //   }
    // },
    toggleSortBy(data) {
      this.is_active = data;
      this.setBeSortBy(this.is_active);
      this.scrollIntoView();
      this.loadSearchByRoomType();
      this.filter_active = false;
      this.popup_active = false;
    },
    toggleBookingRate(data) {
      if (this.is_booking_dropdown == data) {
        this.is_booking_dropdown = '';
        this.handlePopupFilter(false);
      } else {
        this.is_booking_dropdown = data;
        this.popup_active = true;
        this.popup_active_true = true;
      }
    },
    toggleBookingRateCart(type, data, qty = 1) {
      let room_selected = data;
      if (type == 'add') {
        if (this.is_booking_rate_cart.length == 0) {
          room_selected['qty'] = qty;
          this.is_booking_rate_cart.push(room_selected);
        } else {
          let is_exist = false;
          for (let i = 0; i < this.is_booking_rate_cart.length; i++) {
            if (room_selected.id == this.is_booking_rate_cart[i].id) {
              is_exist = i;
              break;
            }
          }
          if (is_exist === false) {
            room_selected['qty'] = qty;
            this.is_booking_rate_cart.push(room_selected);
          } else {
            this.is_booking_rate_cart[is_exist].qty = qty;
          }
        }
      } else {
        this.is_booking_rate_cart.splice(data, 1);
      }
      this.is_booking_dropdown = false;
      this.show_rate = false;
      this.cartTotalPrice();
      this.cartTotalDate();
      // BeMapRoomModalLegacy has already committed the cart mutation by the
      // time this fires -- close it instead of leaving the guest staring at
      // the same room they just booked from the map popup
      if (type == 'add') this.closeMapRoomType();
    },
    cartTotalGuest() {
      let total_guest =
        parseInt(this.search_filter_guest.adult) +
        parseInt(this.search_filter_guest.child) +
        parseInt(this.search_filter_guest.infant);
      return parseInt(total_guest);
    },
    cartTotalDate() {
      var diff = 0;
      let check_in = moment(this.search_filter_date.startDate).format(
        'YYYY-MM-DD'
      );
      let check_out = moment(this.search_filter_date.endDate).format(
        'YYYY-MM-DD'
      );
      diff = moment(check_out).diff(moment(check_in)) / (1000 * 3600 * 24);
      this.total_night = diff;
      return diff;
    },
    cartTotalQty(data = 1) {
      let total_qty = 0;
      for (let i = 0; i < data.length; i++) {
        total_qty += data[i].qty;
      }
      return total_qty;
    },
    cartTotalPrice(data = 1) {
      let total_price = 0;
      for (let i = 0; i < data.length; i++) {
        total_price +=
          data[i].best_price.final_price * data[i].qty * this.total_night;
      }
      return total_price;
    },
    totalRateBreakdown(data) {
      const showTax = this.getMerchant().search_room_is_show_tax_fee_note
      let total_price_breakdown = 0;
      for (let i = 0; i < data.length; i++) {
        total_price_breakdown += data[i].final_price;
        if(!showTax) total_price_breakdown -= data[i].taxes
      }
      return total_price_breakdown;
    },
    detailRoom(data) {
      this.detail_room = !this.detail_room;
      this.detail_room_type = data;
      this.popup_active_true = true;
      if (!this.detail_room) {
        this.releaseRoomTypeDetailStep();
        return;
      }
      /* Only while stacked on the map popup: reached from the plain room list
         this modal keeps its existing Back behaviour. */
      if (this.map_room_type_ref) {
        this.room_type_detail_step = pushHistoryStep(this.dismissRoomTypeDetail);
      }
    },
    dismissRoomTypeDetail() {
      this.room_type_detail_step = null;
      this.detailRoom();
    },
    releaseRoomTypeDetailStep() {
      if (!this.room_type_detail_step) return;
      const step = this.room_type_detail_step;
      this.room_type_detail_step = null;
      releaseHistoryStep(step);
    },
    toggleRateBreakdown(type, data) {
      if (type == 'rates') {
        if (this.show_rate != data) {
          this.show_rate = data;
          this.popup_active_true = true;
        } else {
          this.show_rate = false;
        }
      } else if (type == 'rates-breakdown') {
        if (this.show_rate_breakdown != data) {
          this.show_rate_breakdown = data;
          this.show_rate = data;
          this.popup_active_true = true;
        } else {
          this.show_rate_breakdown = false;
        }
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      this.scrollHeader();
    },
    scrollIntoView() {
      document.getElementById('category-room').scrollIntoView({
        behavior: 'smooth',
      });
    },
    scrollHeader() {
      let st = window.scrollY;
      if (st < this.lastScrollTop) {
        this.header_scroll = true;
      } else {
        this.header_scroll = false;
      }
      this.lastScrollTop = st;
    },
    isToggleEfect(id, data) {
      if (id != 'use_min' && id != 'use_max') {
        if (
          (id == 'min' && data && this.is_range_price.use_min) ||
          (id == 'max' && data && this.is_range_price.use_max)
        ) {
          this.is_range_price[id] = data;
          let self = this;
          // this.$nextTick(() => {
          //   self.$refs[id].focus()
          //   self.$refs[id].select()
          // })
        }
        if (!data) {
          var regex_first_zero = /^(?:[1-9][0-9]*|0)$/;
          var regex_number_comma_dot = /^[0-9.,]+$/;
          let index = id == 'min' ? 0 : 1;
          if (regex_number_comma_dot.test(this.range_price[index]) == false) {
            this.range_price[index] = 0;
          } else if (regex_first_zero.test(this.range_price[index]) == false) {
            this.range_price[index] = +this.range_price[index];
          }
          this.is_range_price[id] = data;
        }
      } else {
        this.is_range_price[id] = !this.is_range_price[id];
      }
    },
    toggleResertCart() {
      const filterChanged = !isSameBeFilter(this.lastSearchedFilter, this.search_filter);

      if (filterChanged && this.getBeCartRoom().length > 0) {
        this.pendingCartReset = JSON.parse(JSON.stringify(this.search_filter));
        this.popupConfirmation = {
          show: true,
          title: this.$t('hotel.search-filter-changed-title'),
          subtitle: this.$t('hotel.search-filter-changed-desc'),
        };
        return;
      }

      if (filterChanged) {
        this.BeManipulateRoomRate('reset');
      }
      this.lastSearchedFilter = JSON.parse(JSON.stringify(this.search_filter));
    },
    setConfirmationModal(data = { show: false, title: '', subtitle: '' }) {
      this.popupConfirmation = data;
      if (!data.show) this.pendingCartReset = null;
    },
    confirmCartResetOnFilterChange() {
      this.popupConfirmation = { show: false, title: '', subtitle: '' };
      if (!this.pendingCartReset) return;
      this.BeManipulateRoomRate('reset');
      this.lastSearchedFilter = this.pendingCartReset;
      this.pendingCartReset = null;
    },
    toggleUpdateCart() {
      this.setBeFilter(this.search_filter);
      this.vuexSearchFilter();
    },

    removeRoomRate(cart) {
      this.beRemoveRoomRate(cart.room_rate.id);
      let roomtype_params = {
        id: cart.room_rate.room_type.id,
        rr_id: cart.room_rate.id,
        qty: cart.qty,
        action: 'inc',
        is_virtual: cart.room_rate.room_type.is_virtual,
        availability_affected: cart.room_rate.room_type.availability_affected,
      };
      this.changeBeRoomAvbl(roomtype_params);
    },
    validateAllFilter() {
      return new Promise((done) => {
        if (this.getMembershipRewardApplied().id) {
          this.resetFilterSearch(false);
        }
        done();
      });
    },
    // load data
    loadSearchByRoomType(validateSelectedPromotion = false) {
      this.is_load = true;
      this.message = '';
      this.room = [];
      this.flexible_dates = [];
      this.flexible_dates_loading = true;
      this.setBeFilter(this.search_filter);
      const params = this.getParamsRoomList(validateSelectedPromotion);
      get('CORE_HOTEL', 'search-room', params).then((response) => {
        let res = response.data;
        if (res.success) {
          trackEvent('view_item_list', {
            params: params,
            result: res.data
          })
          this.all_room = res.room_type_availability;
          this.room = res.data.map((x) => {
            x.room_rate = x.room_rate.map((y, y_i) => {
              let id_ori = y.id;
              y.id_ori = id_ori;
              y.id = `${id_ori}_${y_i}`;
              return y;
            });
            return x;
          });
          let add_original_availability = res.room_type_availability.map(
            (x) => {
              x.original_availability = x.availability;
              return x;
            }
          );
          this.setBeRoomAvbl(add_original_availability);
          document.getElementById('hotel-room').scrollIntoView({
            behavior: 'smooth',
          });
          if(this.$isNotEmptyV2(res.data) && this.$isNotEmptyV2(this.getMerchant().google_tag_manager_id)) this.sendUserGuestData(res.data[0], params)
          this.$sendEventMetaConversionsAPI('Search');
        } else {
          this.message = this.$t('hotel.error.' + res.message);
        }
        this.is_load = false;
      });
    },
    getParamsRoomList(validateSelectedPromotion) {
      try {
        const promotion = this.getParamsRoomListPromotion(validateSelectedPromotion);
        const stayDate = this.getParamsRoomListStayDate();
        const guests = this.getParamsRoomListGuest();
        const price = this.getParamsRoomListPrice();
        const membership = this.getParamsRoomListMembership();
        const specificFilter = this.getParamsRoomListSpecificFilter();

        return {
          ...promotion,
          ...stayDate,
          ...guests,
          ...price,
          ...membership,
          ...specificFilter,
          merchant_id: this.getMerchant().id,
          sort_by: this.getBeSortBy(),
          language_code: this.getCurrentLanguage(),
          device: 'desktop',
        };
      } catch (error) {
        throw error;
      }
    },
    getParamsRoomListPromotion(validateSelectedPromotion) {
      let params = { use_promotion_combine: true };
      const {
        promo_code,
        date: { check_in: startDate, check_out: endDate },
      } = this.getBeFilter();

      if (!validateSelectedPromotion && this.$isNotEmptyV2(promo_code)) {
        params.promo_code = promo_code;
        this.resetSelectedPromotion()
      }

      if(this.$isEmpty(params.promo_code)){
        const selected = this.$getSelectedPotentialPromotion({
          startDate,
          endDate,
        }, validateSelectedPromotion);

        if (this.$isNotEmptyV2(selected)) {
          params.promotion_affected = selected.id
          if(selected.promotion_type === 'MEMBERSHIP'){
            const { id: rewardId } = selected.membership_reward.reward;
            params.membership_reward_id = rewardId;
          }
        }
      }

      return withPromotionFilter(params, this.getBePromotionFilterId());
    },
    getParamsRoomListStayDate() {
      const { check_in, check_out } = this.getBeFilter().date;

      return {
        check_in_date: this.$formatDateApi(check_in),
        check_out_date: this.$formatDateApi(check_out),
      };
    },
    getParamsRoomListGuest() {
      const {
        search_room_is_show_filter_pax_child: useChild,
        search_room_is_show_filter_pax_infant: useInfant,
      } = this.getMerchant();

      const { adult, child, infant } = this.getBeFilter().guest;


      let params = {
        adult,
        child: useChild ? child : 0,
        infant: useInfant ? infant : 0,
      }

      if(!this.isNotLogin()){
        params.user_id = this.getCurrentUser().id
      }

      return params;
    },
    getParamsRoomListPrice() {
      const isPriceEmpty = (price) => this.$isEmpty(price) || price === 0;

      return {
        price_min: isPriceEmpty(this.getBePrice()[0]) ? '' : this.getBePrice()[0],
        price_max: isPriceEmpty(this.getBePrice()[1]) ? '' : this.getBePrice()[1],
      };
    },
    getParamsRoomListMembership() {
      if (this.$isNotEmptyV2(this.getMembershipReferral())) {
        const { membership_referral_code, membership_reward_id } = this.getMembershipReferral();
        return { membership_referral_code, membership_reward_id };
      } else if (!this.isNotLogin()) {
        const { id } = this.getMembershipRewardApplied();
        if(this.$isNotEmptyV2(id)){
          return { membership_reward_id: id };
        }
      }
      return {};
    },
    getParamsRoomListSpecificFilter() {
      if (!this.showSpecificFilter) return {};

      const {
        type,
        data: { id },
      } = this.getBeFilterDetail();
      return type === 'room_type' ? { room_type_id: id } : { rate_id: id };
    },
    sendUserGuestData(bestRoom, filter){
      const { check_in_date: checkIn, check_out_date: checkOut, adult, child, infant } = filter;
      const bestRoomRate = bestRoom.room_rate[0];
      const params = { checkIn, checkOut, adult, child, infant,
        room: bestRoom.name,
        roomRate: bestRoomRate.name,
        bestPrice: bestRoomRate.dates.reduce((acc, value) => acc + value.final_price, 0)
      }

      this.$sendHotelUserGuestDataLayer("availability", params);
    },
    resetFilterSearch(with_reload = true) {
      this.search_filter = JSON.parse(JSON.stringify(this.getBeFilter()));
      this.search_filter.date.check_in = new Date();
      this.search_filter.date.check_out = moment(
        this.search_filter.date.check_in
      )
        .add(this.$defaultFilterBE('night'), 'd')
        .toDate();
      this.search_filter_date.startDate = this.search_filter.date.check_in;
      this.search_filter_date.endDate = this.search_filter.date.check_out;
      this.search_filter.guest.adult = this.$defaultFilterBE('adult');
      this.search_filter.guest.child = 0;
      this.search_filter.guest.infant = 0;
      this.search_filter.promo_code = '';
      this.setBeFilter(this.search_filter);
      this.resetSelectedPromotion();
      this.toggleResertCart();
      if (with_reload) {
        this.loadSearchByRoomType();
      }
      this.vuexSearchFilter();
      this.toggleFilterPrice('delete');
    },
    loadMerchantList() {
      return new Promise((success, fail) => {
        get('COMMUNITY', 'merchant-list', {
          community_id: this.getMerchant().community.id,
          merchant_type: 'hotel',
        }).then((response) => {
          let res = response.data;
          if (res.success) {
            this.merchant_community.list = res.data;
            this.merchant_community.list.unshift({
              name: 'All Property',
              id: 'all',
            });
            this.merchant_community.selected = res.data.find(
              (x) => x.id == this.getMerchant().id
            );
            success();
          } else {
            fail(res.message);
          }
        });
      });
    },
    searchClicked() {
      if (!this.is_load) {
        if (!this.$showCommunity() || this.merchant_community.selected.id == this.getMerchant().id) {
          this.toggleBeSearch();
          this.handlePopupFilter(false);
          this.toggleUpdateCart();
          this.toggleResertCart();
          this.trackSearchClick();
          this.filter_key++;
        } else {
          if (this.merchant_community.selected.id == 'all') {
            this.goToGroup();
          } else {
            let params = `hotel-filter-redirect/${this.search_filter_date.startDate}/${this.search_filter_date.endDate}`;
            if (this.search_filter_promo_code != '') {
              params += `/${this.search_filter_promo_code}`;
            } else {
              params += '/promo_code_empty';
            }
            params += `?guest=${this.search_filter_guest.adult}-${this.search_filter_guest.child}-${this.search_filter_guest.infant}`;
            let merchant_url = `${window.location.origin}/${this.merchant_community.selected.code}/${params}`;
            window.open(merchant_url, '_self');
          }
        }
      }
    },
    backToHomepage() {
      if (this.$showCommunity()) this.goToGroup();

      const useCustomHomepageUrl =
        this.getMerchant().search_room_custom_homepage_url;
      if (this.$isNotEmptyV2(useCustomHomepageUrl)) {
        this.$openLink(useCustomHomepageUrl);
        return;
      }

      this.$router.push(`/${this.getMerchant().code}`);
    },
    goToGroup() {
      let community_url = `${window.location.origin}/${
        this.getMerchant().community.code
      }/group`;
      window.open(community_url, '_self');
    },
    selectOtherMerchant(merchant) {
      this.merchant_community.selected = merchant;
      this.handlePopupFilter(false);
    },
    resetSavedReward() {
      this.setMembershipRewardApplied({});
      this.searchClicked();
    },
    openFilterDate() {
      this.$refs.filter_date.toggleCalendar();
    },
  },
};
</script>
<style scoped>
.top-90 {
  top: 90px !important;
}
.padding-y-6px {
  padding-top: 6px;
  padding-bottom: 6px;
}

.bg-room {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 50px;
  z-index: 1028;
  height: 290px;
}

@media screen and (max-width: 992px) {
  .px-5 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media screen and (max-width: 1200px) {
  .px-5 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
}

.rooms-guest:after,
.rooms-guest:before {
  position: absolute;
  display: inline-block;
  content: '';
  top: -6px;
}

.rooms-guest:after {
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  border-left: 7px solid transparent;
}

.rooms-guest:before {
  top: -7px;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #ccc;
}

.filter-r {
  right: 0 !important;
  transition-delay: 0.14s;
}

.filter-w {
  width: 300px !important;
  transition-delay: 0.16s;
}
</style>
<style>
.promo-suggestion-box {
  background: #FFF9F3;
  border: 1px solid #EEDCCB;
  border-left: 4px solid var(--merchant-primary-color);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
}
.promo-suggestion-box:hover {
  background: #FFF4E8;
  border-color: #DAB99C;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(167, 122, 85, 0.12) !important;
}
.promo-suggestion-box .icon-wrapper {
  color: var(--merchant-primary-color);
  background: white;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(167, 122, 85, 0.1);
}
.promo-suggestion-box .promo-title {
  color: #5D4037;
  letter-spacing: -0.01em;
}
.promo-suggestion-box .promo-desc {
  color: #795548;
  line-height: 1.5;
}
.promo-suggestion-box .apply-btn {
  background-color: var(--merchant-primary-color);
  color: white;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(167, 122, 85, 0.2);
}
.promo-suggestion-box:hover .apply-btn {
  background-color: #8C613D;
  transform: scale(1.02);
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/RoomDesktop.vue